import { CertificateImage, CertificateText, Error, Loader } from "components";
import { useRouter } from "next/router";
import { fetchCertificateData, fetchCertificateImg } from "queries";
import { useQuery } from "react-query";
import classNames from "utils/classNames";

const Certificate = () => {
	const { query } = useRouter();
	const { certificateId } = query;
	const {
		isLoading: isLoadingData,
		data: certificate,
		error: errorData,
	} = useQuery(
		[`Data-${certificateId}`, certificateId],
		fetchCertificateData,
		{
			enabled: Boolean(certificateId),
			retry: false,
		}
	);
	const {
		isLoading: isLoadingImg,
		data: certificateImg,
		error: errorImg,
	} = useQuery(
		[`Img-${certificateId}`, certificateId],
		fetchCertificateImg,
		{
			enabled: Boolean(certificate?.isNew),
			retry: false,
		}
	);

	if (isLoadingData)
		return (
			<div className="flex h-navScreen w-full items-center justify-center">
				<Loader />
			</div>
		);
	if (errorData)
		return (
			<div className="flex h-navScreen w-full items-center justify-center">
				<Error text={errorData.response.data.results.data.error} />
			</div>
		);

	return certificate && !errorData ? (
		<>
			{/* <NextSeo
				title="LetsUpgrade"
				titleTemplate="LetsUpgrade"
				defaultTitle="LetsUpgrade"
				description="Enroll in Letsupgrade's online courses to gain certification in data science, digital marketing, product management, machine learning, software development, and more. Get the unique LetsUpgrade Online gamified  learning experience - learn through a content co-developed by academia and industry experts & get a dedicated mentor and career support."
				canonical="https://www.letsupgrade.in/"
				openGraph={{
					url: "https://www.letsupgrade.in/",
					title: "LetsUpgrade",
					type: "website",
					description:
						"Enroll in Letsupgrade's online courses to gain certification in data science, digital marketing, product management, machine learning, software development, and more. Get the unique LetsUpgrade Online gamified  learning experience - learn through a content co-developed by academia and industry experts & get a dedicated mentor and career support.",
					site_name: "LetsUpgrade",
					images: [
						{
							url: `${certificateImg.base64}`,
							width: 800,
							height: 420,
							alt: "Certificate",
						},
					],
				}}
				// twitter={{
				// 	handle: "@avneesh0612",
				// 	site: "@avneesh0612",
				// 	cardType: "summary_large_image",
				// }}
			/> */}
			<div
				className={classNames(
					"mx-auto flex w-full max-w-7xl flex-wrap space-y-10 bg-white px-4 sm:px-6 md:flex-nowrap md:space-x-6 md:space-y-0 lg:px-14",
					certificate?.isNew
						? "mt-10"
						: "min-h-navScreen items-center"
				)}
			>
				{certificate?.isNew && (
					<CertificateImage
						isLoadingImg={isLoadingImg}
						certificateImg={certificateImg}
						errorImg={errorImg}
					/>
				)}
				<CertificateText
					certificate={certificate.details}
					isNew={certificate.isNew}
					certificateImg={certificateImg?.url}
				/>
			</div>
		</>
	) : (
		<div className="flex h-navScreen w-full items-center justify-center">
			<Loader />
		</div>
	);
};

export default Certificate;
